import { html } from '@design.estate/dees-element';
import { demoPage } from '../../../demos/templates.js';
import type { THarnessContentBlock } from '../interfaces.js';

// 1×1 px png (red) as a stand-in for tool screenshot output
const tinyPngBase64 = 'iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z8BQDwAEhQGAhKmMIQAAAABJRU5ErkJggg==';

const demoBlocks: THarnessContentBlock[] = [
  { type: 'text', text: 'Query returned 3 rows. Full result set embedded below.' },
  { type: 'image', data: tinyPngBase64, mimeType: 'image/png' },
  {
    type: 'resource',
    resource: {
      uri: 'file:///srv/reports/summary.csv',
      mimeType: 'text/csv',
      text: 'id,name,status\n1,alpha,ok\n2,beta,ok\n3,gamma,degraded',
    },
  },
  {
    type: 'resource_link',
    uri: 'https://example.com/dashboards/deploy-42',
    name: 'deploy-42',
    title: 'Deploy #42 dashboard',
    description: 'Grafana panel for the deploy window',
    mimeType: 'text/html',
    size: 12_480,
  },
];

export const demoFunc = () => demoPage('Content blocks', 'Text, media and linked resources in one conversation.', html`
  <div class="blocksDemo dees-demo-stack">
    <dees-harness-content-blocks .blocks=${demoBlocks}></dees-harness-content-blocks>
  </div>
`);
